import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Loader, Alert } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';

var DeliveryIndicator = (_param)=>{
    var { labels , loading , error , view ='full' , deliveryMessage , fallbackLabel , tooltipSlot , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "labels",
        "loading",
        "error",
        "view",
        "deliveryMessage",
        "fallbackLabel",
        "tooltipSlot",
        "className"
    ]);
    if (loading && !error) {
        return /*#__PURE__*/ React__default.createElement("div", {
            className: "delivery-indicator"
        }, /*#__PURE__*/ React__default.createElement(Loader, null));
    }
    if (error || view !== 'short' && !deliveryMessage) {
        return fallbackLabel ? /*#__PURE__*/ React__default.createElement("div", {
            className: "delivery-indicator"
        }, fallbackLabel) : null;
    }
    const messageElement = /*#__PURE__*/ React__default.createElement("p", {
        className: "delivery-indicator__message"
    }, deliveryMessage);
    const tooltipElement = tooltipSlot ? /*#__PURE__*/ React__default.createElement("div", {
        className: "delivery-indicator__tooltip-slot"
    }, tooltipSlot) : null;
    let content = null;
    switch(view){
        case 'short':
            content = (labels === null || labels === void 0 ? void 0 : labels.deliveryIndication) ? /*#__PURE__*/ React__default.createElement("span", {
                className: "delivery-indicator__message",
                "data-t": "delivery-short"
            }, labels.deliveryIndication) : null;
            break;
        case 'text':
            content = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, messageElement, tooltipElement);
            break;
        case 'icon':
            content = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("span", {
                className: "delivery-indicator__icon"
            }, /*#__PURE__*/ React__default.createElement(Icon, {
                name: "delivery"
            })), /*#__PURE__*/ React__default.createElement("div", {
                className: "delivery-indicator__icon-content"
            }, messageElement, tooltipElement));
            break;
        case 'full':
            content = /*#__PURE__*/ React__default.createElement(Alert, {
                type: "info",
                icon: "delivery",
                "data-t": "delivery-alert"
            }, messageElement, tooltipElement);
            break;
        default:
            throw new Error(`Undefined view: ${view}`);
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        "data-t": rest['data-t'],
        className: classnames('delivery-indicator', `delivery-indicator--${view}`, className)
    }, content);
};

export { DeliveryIndicator };
//# sourceMappingURL=DeliveryIndicator.js.map
